import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import Modal from '../../components/Modal'
import { Checkbox, Input } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import Li from '../../components/Li'
import Loader from '../../components/Loader'
import { createReportGroup, getReportGroup, updateReportGroup } from '../../actions/reportGroups'
import Confirmation from '../../components/Confirmation/Confirmation'
import styles from './styles.module.css'

export default function ReportGroupsModal({ data, closeModal }) {
  const dispatch = useDispatch()

  const { list: reports } = useSelector(state => state.reports)
  const { data: details, loading } = useSelector(state => state.report_groups)

  const addMode = !data?.id

  const [selectedIds, setSelectedIds] = useState([])

  const uniqueReports = [...new Map(reports?.map(item => [item.xp_rpt_id, item])).values()]

  useEffect(() => {
    if (addMode) return
    dispatch(getReportGroup(data.id))
  }, [data])

  useEffect(() => {
    if (addMode || !details) return setSelectedIds([])
    setSelectedIds(details.filter(d => d.used).map(d => d.xp_rpt_id))
  }, [details])

  const handleCreateReportGroup = async (values) => {
    await dispatch(createReportGroup(values, selectedIds))
    closeModal()
  }

  const handleUpdateReportGroup = async (values) => {
    const { id, ...payload } = values
    await dispatch(updateReportGroup(id, payload, selectedIds))
    closeModal()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit
  } = useFormik({
    initialValues: addMode ? { name: '' } : data,
    enableReinitialize: true,
    validateOnChange: true,
    onSubmit: addMode ? handleCreateReportGroup : handleUpdateReportGroup
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  const onReportClick = (reportId) => () => {
    const newIds = selectedIds.includes(reportId) ? selectedIds.filter(id => id !== reportId) : [...selectedIds, reportId]
    setSelectedIds(newIds)
  }

  const renderLi = ({ name, xp_rpt_id }) => {
    const checked = selectedIds.includes(xp_rpt_id)
    return (
      <Li key={xp_rpt_id} onClick={onReportClick(xp_rpt_id)}>
        <span>{name}</span>
        <Checkbox checked={checked} />
      </Li>
    )
  }

  return (
    <Modal open={!!data} onClose={handleClose} closeOnOverlayClick={true} closeOnEsc={true}>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <Input
              label='Название'
              name='name'
              value={values.name}
              error={error('name')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          {loading && <Loader />}
          {!loading && (
            <div>
              <p>Отчеты</p>
              <ul>{uniqueReports?.map(renderLi)}</ul>
            </div>
          )}
        </div>
      </div>
      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}
